// extracted by mini-css-extract-plugin
module.exports = {"infoModal":"NoteShortcutModal_infoModal__1KIem","okBtn":"NoteShortcutModal_okBtn__2aj_D"};